<template>
  <div class="home">
    <transition name="van-fade">
      <div class="hide-popue" v-show="$store.state.showPopur"></div>
    </transition>
    <transition name="van-slide-right">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      //是否禁用搜索框
      searchDisabled: true,
    };
  },
  components: {},
  methods: {
    //跳转
    goSearchList() {},
  },
  created() {},
};
</script>

<style lang="less" scoped>
.hide-popue {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 98;
}
.home {
  padding-bottom: 0.55rem;
}
// .slider-enter,
// .slider-leave-to {
// 	left: 100%;
// }
// .slider-enter-active,
// .slider-leave-active {
// 	transition: left 5s;
// }
// .slider-enter-to,
// .slider-leave {
// 	left: 0;
// }
</style>
